import { render, staticRenderFns } from "./addSubLibrary.vue?vue&type=template&id=33b4a1b4"
import script from "./addSubLibrary.vue?vue&type=script&lang=js"
export * from "./addSubLibrary.vue?vue&type=script&lang=js"
import style0 from "./addSubLibrary.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports